// Module switches. Set to true to bring a hidden module back for all accounts.
export const STOCK_TAKE_ENABLED = false;
